/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[rel=external]:after{background:url(/assets/images/icons8-external-link.svg) center right/18px no-repeat;padding:0 10px;content:\" \"}a[rel=salesforce]:after{background:url(/assets/images/icons8-salesforce.svg) center right/18px no-repeat;padding:0 10px;content:\" \"}"];
export { styles as styles };
